
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/forgotPassword",
      function () {
        return require("private-next-pages/[lang]/forgotPassword.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/forgotPassword"])
      });
    }
  